<style lang="less" scoped>
.btn-right-mes {
  margin-left: 10px;
  line-height: 32px;
}

.withdrawal-mes {
  margin: 0px 0px 16px 30px;
}

/deep/ .hide .el-upload--picture-card {
  display: none;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">设备变更站点</div>
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">电站名称</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.stationName"
                clearable
                filterable
                no-data-text="暂无数据"
              >
                <el-option
                  v-for="item in siteArr"
                  :key="item.stationName"
                  :label="item.stationName"
                  :value="item.stationName"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">时间范围</div>
            <div class="query-inputs-div flex-1">
              <el-date-picker
                class="full-width"
                v-model="searchTime"
                :picker-options="pickerOptions"
                clearable
                style="width:340px;"
                type="daterange"
                size="small"
                value-format="yyyy-MM-dd"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="handleDateChange"
              ></el-date-picker>
            </div>
          </div>
        </template>
        <template slot="actions">
          <button
            class="common-bg-button"
            @click="getListData(pagination, true)"
          >
            查 询
          </button>
          <button class="common-bg-button" @click="handleExport">导 出</button>
        </template>
      </ZD-list-querys>
      <!-- 表格 -->
      <div class="list-table">
        <el-table
          :data="tableData"
          style="width: 100%"
          border
          stripe
          @selection-change="
            (sels) => {
              selections = sels;
            }
          "
        >
          <el-table-column
            prop="dearName"
            label="运营商名称"
            width="200"
            align="center"
          />
          <el-table-column
            prop="dearNo"
            label="运营编码"
            width="200"
            align="center"
          />
          <el-table-column
            prop="platformName"
            label="对接平台名称"
            width="200"
            align="center"
          />
          <el-table-column
            prop="platformNo"
            label="对接平台编码"
            width="200"
            align="center"
          />
          <el-table-column
            prop="stationName"
            label="设备所属当前站点名称"
            width="200"
            align="center"
          />
          <el-table-column
            prop="stationNo"
            label="设备所属当前站点编码"
            width="200"
            align="center"
          />
          <el-table-column
            prop="pileNo"
            label="设备编码"
            width="200"
            align="center"
          />
          <el-table-column
            prop="pileNo2"
            label="接口编码"
            width="200"
            align="center"
          />
          <el-table-column
            prop="null"
            label="设备所在原站点名称"
            width="200"
            align="center"
          />
          <el-table-column
            prop="null"
            label="设备所在原站点编码"
            width="200"
            align="center"
          />
          <el-table-column
          
            label="挪桩变更原因"
            width="200"
            align="center"
          >
          <template>
              平台数据整理
          </template>
          </el-table-column>
          <el-table-column
            prop="createdByName"
            label="操作人"
            width="200"
            align="center"
          />
          <el-table-column
            prop="createdWhen"
            label="操作时间"
            width="200"
            align="center"
          />
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
import util from "@/common/util.js";
import utils from "@/utils/utils.js";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      pagination: pageConfig.pagination,
      dealerArr: [], // 运营类别
      siteArr: [], // 电站名称
      tableData: [], // 表格数据
      selections: [], // 表格选项
      queryInfo: {
        
        pageNum: "",
        pageSize: "",
      }, //标签页与 搜索框
      pickerMinDate: "",
      searchTime: [],
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.pickerMinDate = minDate.getTime();
          //如果选中结束时间,则小于所选当前时间
          if (maxDate) {
            this.pickerMinDate = "";
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate !== "") {
            let one = 30 * 24 * 3600 * 1000;
            let minTime = this.pickerMinDate - one;
            let maxTime = this.pickerMinDate + one;
            if (maxTime > new Date()) {
              maxTime = new Date();
            }
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
          return time.getTime() > Date.now();
        },
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      this.getListData(this.pagination, true);
      this.getSite();
    },
   
    handleDateChange(val) {
      if (val) {
        this.queryInfo.fromTime = val[0] + " 00:00:00"
        this.queryInfo.endTime = val[1] + " 23:59:59"
      } else {
        this.searchTime = [];
        this.queryInfo.fromTime = "";
        this.queryInfo.endTime = "";
      }
    },
    // 电站数据
    getSite() {
      let _ = this;
      let obj = {};
      obj.dealerNo = Array.from(new Set(_.dealNo)).join(",");
      obj.isHostOperate = _.queryInfo.isHostOperate;
      _.$H.post(_, _.$A.pileStation.listStationByDeal, obj).then((res) => {
        _.siteArr = res.data.data || [];
        // _.siteArr.unshift({
        //   stationName: "全部电站",
        // });
      });
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.type = '02'
      _.$H.post(_, _.$A.operationManagement.page, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },

    // 导出
    handleExport() {
      let _ = this;
      _.queryInfo.exportType = '01'
        _.$U.showLoading(_);
        _.$H
          .post(_, _.$A.operationManagement.export, _.queryInfo)
          .then((res) => {
            _.$U.hideLoading(_);
            let filePath = res.data.data.data;
            // let downUrl = "http://192.168.8.208:9000" + filePath; // 后台本地地址
            // let downUrl = "http://192.168.8.174:7999" + filePath; // 测试地址
            let downUrl = "http://ocharge.shzhida.com:6777" + filePath; // 正式地址
            window.open(downUrl, "_blank");
          });
      
    },
    // 编辑、查看 电站
    handleEditStationName(row) {
      let _ = this;
      _.$store.commit("setEditId", row.stationId);
      window.open(
        _.$router.resolve({
          name: "pileStationDetail",
          query: { editId: row.stationId },
        }).href,
        "_blank"
      );
    },
    // 编辑、查看 桩编号
    handleEditPileCode(row) {
      let _ = this;
      _.$store.commit("setEditId", row.pileCode);
      window.open(_.$router.resolve({ name: "pileDetail" }).href, "_blank");
    },
    // 更新数据
    handleClick(row) {
      let _ = this;
      // _.$U.showLoading(_);
      // _.$H.post(_, _.$A.pileStation.del, { staticId: row.staticId }).then((res) => {
      //     _.getListData(this.pagination, true);
      //     _.$U.showLoading(_);
      // });
    },
  },
};
</script>
